<template>
  <div class="notice">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'Notice'
  }
</script>

<style scoped>
  .notice {
    background: #3Af;
    color: #fff;
    font-weight: 400;
    padding: 16px;
    margin: 16px;
  }
</style>
<style>
  .notice a {
    color: #fff;
    font-weight: 700;
  }
</style>
